import React, { useState, useEffect } from "react";
import { Row, Col, Container, Card } from "reactstrap";
import "./CSS/WidgetInfo.css";
// import { getMachineDetails } from "../API/Api";

const WidgetInfo = (props) => {
  const { station, count } = props;

  //console.log(machineCard)
  return (
    <Row className="justify-content-center mx-3">
      {/* <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}></Col> */}
      {/* <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} > */}
      <Container fluid className="justify-content-center align-items-center">
        <Card
          className="p-2 info_widget widget-text"
          style={{
            border: "1px solid #F1F2F3",
            borderRadius: "8px",
          }}
        >
          {station === "K#EBM" ? (
            <>
              <Row className="text-start">
                <span>
                  EBM Defect Count:{" "}
                  <strong className="red-color">{count}</strong>
                </span>
              </Row>
            </>
          ) : (
            <></>
          )}
          {station === "K#CSS" || station === "K#UBS" || station === "K#ALL" ? (
            <>
              <Row>
                <Col className="widget-text">
                  <span>
                    Sealant Miss: <strong className="red-color">0</strong>{" "}
                  </span>
                </Col>
                <Col className="widget-text">
                  <span>
                    Sealant Break: <strong className="red-color">0</strong>
                  </span>
                </Col>
                <Col className="widget-text">
                  <span>
                    Bead Split: <strong className="red-color">0</strong>
                  </span>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Card>
      </Container>
      {station === "K#CSS" || station === "K#UBS" || station === "K#ALL" ? (
        <>
          <Container
            fluid
            className="justify-content-center align-items-center"
          >
            <Card
              className="p-2 info_widget widget-text"
              style={{
                border: "1px solid #F1F2F3",
                borderRadius: "8px",
              }}
            >
              <Row>
                {" "}
                <Col className="widget-text">
                  <span>
                    Total Defect Count: <strong className="red-color">{count}</strong>
                  </span>
                </Col>
              </Row>
            </Card>
          </Container>
        </>
      ) : (
        <></>
      )}

      {/* </Col> */}
      {/* <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}></Col> */}
    </Row>
  );
};
export default WidgetInfo;
